import ShareButton, { ShareButtonProps } from './ShareButton';

export default ShareButton;
export type { ShareButtonProps };
